export default __webpack_public_path__ + "resources/icons/n130-fa15.webp";